import { gql, useLazyQuery as useLazyQueryHook } from "@apollo/client";
import { Server } from "../apollo/types";
import {
  PublicProviderObject,
  QueryProvidersByShortIdsArgs,
} from "@grow-therapy-team/seedling-components";

export const GET_PROVIDERS_BY_SHORT_IDS = gql`
  query ProvidersByShortIds($values: GetProvidersByShortIdsQueryInput!) {
    providersByShortIds(values: $values) {
      shortId
      state
    }
  }
`;

const useLazyQuery = useLazyQueryHook<
  {
    providersByShortIds: Pick<
      PublicProviderObject,
      "shortId" | "name" | "pronouns" | "description" | "state"
    >[];
  },
  QueryProvidersByShortIdsArgs
>;

export function useGetPublicProvider() {
  const [fetchPublicProviders] = useLazyQuery(GET_PROVIDERS_BY_SHORT_IDS, {
    context: { server: Server.MONOLITH, skipAuth: true },
  });

  return async (providerShortId: string) => {
    const result = await fetchPublicProviders({
      variables: { values: { shortIds: [providerShortId] } },
    });
    return {
      ...result,
      data: result.data?.providersByShortIds?.[0],
    };
  };
}
